// extracted by mini-css-extract-plugin
module.exports = {"inverseLogo":"styles_inverseLogo__3-7xy"};